// extracted by mini-css-extract-plugin
export var dropdownButton = "_3w-0";
export var fullWidthDropdownButton = "_3w-1";
export var icon = "_3w-3";
export var iconPlaceholder = "_3w-2";
export var menuItemRow = "_3w-5";
export var shortcutContainer = "_3w-4";